<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import therapyApi from '@/services/api/thrpy.api';
import reportApi from '@/modules/report/api';
import DocumentsService from '@//modules/report/document';

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-chart-pie',
      title: 'Informe Pago Reembolso',
      routes: ['Inicio', 'Informes Generales', 'Informe Pago Reembolso'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
        },
        filters: {
          academicYear: null,
          dateTo: null,
          dateFrom: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico',
          validations: 'required',
          class: 'col-md-3',
          clearable: false,
          onChanged: this.onChangeAcademicYear,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
        {
          name: 'dateFrom',
          component: 'custom-date-picker',
          label: 'Rango de Fecha',
          placeholder: 'Fecha Desde',
          error: 'Favor de seleccionar la fecha',
          validations: 'required',
          class: 'col-md-2',
          maxDate: new Date(),
          value: this.model.search.filters.dateFrom,
        },
        {
          name: 'dateTo',
          component: 'custom-date-picker',
          label: ' ',
          placeholder: 'Fecha Hasta',
          error: 'Favor de seleccionar la fecha',
          validations: 'required',
          class: 'col-md-2 pt-2',
          maxDate: new Date(),
          value: this.model.search.filters.dateTo,
        },
      ];
    },
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      const { data: years } = await therapyApi.getDisbursementAcademicYears();
      this.model.search.collections.academicYears = [...years];

      if (this.model.search.collections.academicYears.length > 0) {
        this.model.search.filters.academicYear = this.model.search.collections.academicYears[0];
      }
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (isValid) {
        this.process(
          this.model.search.filters.academicYear,
          this.model.search.filters.dateFrom,
          this.model.search.filters.dateTo
        );
      }
    },
    async process(academicYear, dateFrom, dateTo) {
      if (dateFrom > dateTo) {
        this.ShowToast(
          'Atención',
          'La Fecha Hasta no puede ser menor a la Fecha Desde.',
          'error'
        );
        return;
      }

      const formatYmd = (date) => date.toISOString().slice(0, 10);

      const payload = {
        academicYearId: academicYear.id,
        FromDate: formatYmd(dateFrom),
        ToDate: formatYmd(dateTo),
      };

      reportApi
        .getReport('paymentrefund', payload)
        .then((res) => DocumentsService.Download(res.data));
    },
  },
};
</script>
